import { apiClient, get } from "@/_nucleo/api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FaturaEdicao } from "./_types";

const BASE_PATH = "rpws003/registro";

async function fetchFaturaByRec(REC: string): Promise<FaturaEdicao[]> {
  const { data } = await get<FaturaEdicao[]>(apiClient.production, `${BASE_PATH}?REC=${REC}`);
  // garante que nunca retorne null
  return data || {
    REC: "",
    Z15_COD: "",
    Z15_STATUS: "",
    Z15_DTINC: "",
    Z15_FILIAL: "",
    Z15_FORNEC: "",
    Z15_OBS: "",
    Z15_VALOR: "0",
    Z15_USRINC: "",
    Z15_USRAPR: "",
    titulos: [],
  };
}

export function useFaturaByRec(
  REC: string,
  options?: UseQueryOptions<FaturaEdicao[], Error, FaturaEdicao[]>
) {
  return useQuery<FaturaEdicao[]>({
    queryKey: ["financeiro", "faturas", REC],
    queryFn: () => fetchFaturaByRec(REC),
    staleTime: 5 * 60 * 1000,
    enabled: !!REC,
    ...options
  });
}
